<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div
            v-if="error"
            class="alert alert-dismissible alert-danger">{{ error }}</div>
          <div
            v-if="deletedItem"
            class="alert alert-dismissible alert-success">{{ deletedItem.title }} {{$t('notifications.deleted')}}</div>
        </b-col>
      </b-row>
<!--      <b-row>-->
<!--        <b-col>-->
<!--          <h5>{{$t('views.database.list.title')}}</h5>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link
                :to="{ name: 'DatabaseConnectionCreate' }"
                class="btn btn-primary">{{$t('buttons.create')}}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
              <div v-if="items.length > 0">
                <table class="table table-sm table-striped table-hover">
                  <thead>
                  <tr>
                    <th>{{$t('views.database.list.status')}}</th>
                    <th>{{$t('views.database.list.name')}}</th>
                    <th>{{$t('views.database.list.desc')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr  v-for="item in items"
                       :key="item['@id']">
                    <td>
                      <b-row>
                        <b-col>
                          <span v-if="item.state === states.ACTIVE" v-b-tooltip.hover :title="$t('views.application.list.connectionSuccess')" style="color: #28a745" class="h6 ml-3 mt-0 mb-0"><i class="fa fa-circle mr-2"></i></span>
                          <span v-if="item.state === states.ARCHIVED" v-b-tooltip.hover :title="$t('views.application.list.connectionFailure')" style="color: #dc3545;" class="h6 ml-3 mt-0 mb-0"><i class="fa fa-circle mr-2"></i></span>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row>
                  <b-col>
                    <p>
                      <router-link
                        v-if="item"
                        :to="{name: 'DatabaseConnectionUpdate', params: { id: item['@id'] }}">
                      </router-link>{{ item.title }} ({{item.host}}:{{item.port}})
                    </p>
                  </b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row>
                        <b-col v-if="item.description">
                          <p >
                            {{item.description}}
                          </p>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row>
                  <b-col>
                    <router-link
                      :to="{name: 'DatabaseConnectionUpdate', params: { id: item['@id'] }}"
                      class="float-right">
                      <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                    </router-link>
                  </b-col>
                      </b-row>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                {{$t('notifications.noData')}}
              </div>
              <div v-if="view">
                <pagination
                  :view="view"
                  @getPage="getPage($event)"
                ></pagination>
              </div>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { states } from '../../../../../utils/const/states'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },
  data () {
    return {
      states: states
    }
  },

  computed: mapGetters({
    deletedItem: 'databaseconnection/del/deleted',
    error: 'databaseconnection/list/error',
    items: 'databaseconnection/list/items',
    isLoading: 'databaseconnection/list/isLoading',
    view: 'databaseconnection/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'databaseconnection/list/default'
  })
}
</script>
